import type { EmojiText } from '@/services/forms/types'
import type { FilteredViewSharingType } from '@/data/models/domain/filteredViews/types'

export enum TicketSaveAsModalFormFields {
  name = 'name',
  sharingType = 'sharingType',
  filters = 'filters',
}

export type TicketSaveAsModalFormSchema = {
  [TicketSaveAsModalFormFields.name]: Required<EmojiText>
  [TicketSaveAsModalFormFields.sharingType]: FilteredViewSharingType
}
